import { Outlet } from 'react-router-dom';

import { Auth0Provider } from '@auth0/auth0-react';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const JOHN_DEERE_CALLBACK_PATH = '/account/john-deere/callback';

const AuthenticationProvider: FunctionComponent<Props> = ({
    authorizationParams,
    clientId,
    domain,
    testId = TEST_ID
}) => {
    const skipRedirectCallback = window.location.pathname === JOHN_DEERE_CALLBACK_PATH;

    return (
        <Auth0Provider
            authorizationParams={authorizationParams}
            clientId={clientId}
            data-testid={testId}
            domain={domain}
            skipRedirectCallback={skipRedirectCallback}>
            <Outlet />
        </Auth0Provider>
    );
};

export default AuthenticationProvider;
